import * as types from '../actions/actionTypes';
import _uniq from 'lodash/uniq';
import _reject from 'lodash/reject';
import _extend from 'lodash/extend';
import _find from 'lodash/find';
import _shuffle from 'lodash/shuffle';
// import Data from '../../data';

export default function courseReducer(state = {
    services: [],
    specialisms: [],
    skillsets: [],
    menuVisible: false,
    navBarVisible: false,
    startTransition: false,
    endTransition: false,
    selectedService: false,
    selectedPortfolios: [],
    selectedClients: [],
    loadedClients: [],
    posts: [],
    postsPage: 1,
    postsFilter:false,
    noPostsFound: false,
    loadingPosts: false,
    loadingPortfolio: false,
    loadingPost: false,
    selectedPost: false,
    selectedPortfolio: null,
    loadingAbout: false,
    aboutPage: false,
    termsPage: false,
    privacyPage: false,
    portfoliosPage: 1,
    portfoliosNumber: 20,
    sendingStartProject: false,
    sentStartProject: false,
    sendingEnquiry: false,
    sentEnquiry: false,
    sendingFeedback: false,
    sentFeedback: false,
    loggingIn: false,
    loginError: false,
    user: false
}, action) {
    switch (action.type) {
        case types.SHOW_NAVBAR:
            return Object.assign({}, state, {
            navBarVisible: action.showNavBar
        });
        case types.SHOW_MENU:
            return Object.assign({}, state, {
                menuVisible: action.showMenu
            });

        case types.START_TRANSITION:
            return Object.assign({}, state, {
                startTransition: action.startTransition
            });

        case types.END_TRANSITION:
            return Object.assign({}, state, {
                endTransition: action.endTransition
            });


        case types.LOAD_SERVICES:

            return Object.assign({}, state, {
                    services: action.services
                });

        case types.LOAD_SKILLSETS:

            return Object.assign({}, state, {
                    skillsets: action.services,
                    services: Array.concat(state.specialisms, action.services)
                });

        case types.LOAD_SPECIALISMS:
            return Object.assign({}, state, {
                    specialisms: action.services,
                    services: Array.concat(state.skillsets, action.services)
                });

        case types.GET_SERVICE_BY_TYPE:
            return Object.assign({}, state, {
                    type: action.sType
                });

        case types.SENDING_START_PROJECT:
            return Object.assign({}, state, {
                    sendingStartProject: true
                });

        case types.SENT_START_PROJECT:
            return Object.assign({}, state, {
                    sendingStartProject: false,
                    sentStartProject: true
                });

        case types.SENDING_ENQUIRY:
            return Object.assign({}, state, {
                    sendingEnquiry: true
                });

        case types.SENT_ENQUIRY:
            return Object.assign({}, state, {
                    sendingEnquiry: false,
                    sentEnquiry: true
                });

        case types.SENDING_FEEDBACK:
            return Object.assign({}, state, {
                    sendingFeedback: true
                });

        case types.SENT_FEEDBACK:
            return Object.assign({}, state, {
                    sendingFeedback: false,
                    sentFeedback: true
                });

        case types.PAGE_CHANGE:
            return Object.assign({}, state, {
                pageChange: {
                    next: action.next,
                    prev: action.prev,
                    callback: action.callback
                }
            });

        case types.LOAD_SERVICE_PORTFOLIOS_SUCCESS:

            if(action.page !== state.portfoliosPage && action.page !== 1){
                return Object.assign({}, state, {
                    selectedPortfolios: state.selectedPortfolios.concat(action.service),
                    // loadedClients: _reject(_uniq(state.loadedClients.concat(action.service)), function (o) {
                    //     return !o.acf.branding;
                    // }),
                    portfoliosPage: action.page,
                    portfoliosNumber: action.number,
                    loadingPortfolio: false
                });
            }else{
                return Object.assign({}, state, {
                    selectedPortfolios: action.service,
                    // loadedClients: _reject(_uniq(state.loadedClients.concat(action.service)), function (o) {
                    //     return !o.acf.branding;
                    // }),
                    portfoliosPage: action.page,
                    portfoliosNumber: action.number,
                    loadingPortfolio: false
                });
            }

        case types.LOADING_POSTS:
            return Object.assign({}, state, {
                loadingPosts: true
            });

        case types.LOADING_PORTFOLIO:
            return Object.assign({}, state, {
                loadingPortfolio: true
            });

        case types.LOADING_POST:
            return Object.assign({}, state, {
                loadingPost: true
            });

        case types.LOADING_ABOUT:
            return Object.assign({}, state, {
                loadingAbout: true
            });

        case types.LOAD_POST_SUCCESS:
            return Object.assign({}, state, {
                selectedPost: action.post,
                loadingPost: false
            });

        case types.LOAD_ABOUT_SUCCESS:
            return Object.assign({}, state, {
                aboutPage: action.page,
                loadingAbout: false
            });

        case types.LOAD_PRIVACY_SUCCESS:
            return Object.assign({}, state, {
                privacyPage: action.page
            });

        case types.LOAD_TERMS_SUCCESS:
            return Object.assign({}, state, {
                termsPage: action.page
            });

        case types.LOAD_POSTS_SUCCESS: {
            let filter = action.filter? {
                slug: action.filter.slug,
                taxonomy: action.filter.taxonomy
            }: false;

            if(action.posts.length === 0){
                return Object.assign({}, state, {
                    noPostsFound: true,
                    postsPage: action.page,
                    loadingPosts: false,
                    postsFilter: filter
                });
            }else{
                if(state.postsPage !== action.page){
                    return Object.assign({}, state, {
                        posts: _uniq(state.posts.concat(action.posts)),
                        postsPage: action.page,
                        loadingPosts: false,
                        noPostsFound: false,
                        postsFilter: filter
                    });
                }else{
                    return Object.assign({}, state, {
                        posts: _uniq(action.posts),
                        postsPage: action.page,
                        noPostsFound: false,
                        loadingPosts: false,
                        postsFilter: filter
                    });
                }
            }
        }

        case types.LOAD_SERVICE_CLIENTS_SUCCESS:{
            if(!state.selectedService){
                return Object.assign({}, state, {
                    selectedClients: _reject(_uniq(state.selectedClients.concat(action.service)), function (o) {
                        return !o.acf.branding;
                    })
                });
            }else{
                return Object.assign({}, state, {
                    selectedClients: _reject(_uniq(action.service), function (o) {
                        return !o.acf.branding;
                    })
                });
            }

        }

        case types.LOAD_SERVICE_SUCCESS:
            return Object.assign({}, state, {
                selectedService: _extend(action.service, action.acf)
            });

        case types.SELECT_SERVICE: {
            let selectedPortfolios,
                selectedService,
                list = [];

            if(action.slug.indexOf('/') > -1) action.slug = action.slug.substring(1, action.slug.length);

            // _each(Data.portfolio, function (p) {
            //     if(p.category.includes(action.slug)){
            //         list.push(p);
            //     }
            // });

            selectedPortfolios = _shuffle(list);


            if(_find(state.specialisms, {slug: action.slug}))  selectedService = _find(state.specialisms, {slug: action.slug});
            else selectedService = _find(state.skillsets, {slug: action.slug});

            return Object.assign({}, state, {
                selectedPortfolios, selectedService
            });
        }

        case types.CLEAR_STATE:
            return Object.assign({}, state, {
                selectedPortfolios: false,
                selectedService: false,
                selectedPortfolio: false,
                selectedClients: []
            });

        case types.CLEAR_SELECTED_SERVICE:
            return Object.assign({}, state, {
                selectedService: false,
                selectedClients: []
            });

        case types.SEARCHING_PORTFOLIOS:
            return Object.assign({}, state, {
                searchingPortfolios: true
            });

        case types.SEARCHING_PORTFOLIOS_SUCCESS:
            return Object.assign({}, state, {
                searchingPortfolios: false,
                selectedPortfolios: action.portfolios
            });

        case types.SELECT_PORTFOLIO:{
            let selectedPortfolio;

            let find = _find(state.selectedPortfolios, {slug: action.slug});

            if(find){
                // let client = _find(state.selectedClients, {id: find.acf.client[0]});
                // if(client) _extend(find, {
                //     client: _extend(find.client, client)
                // });
                selectedPortfolio = find;
            }else{
                selectedPortfolio = false;
            }

            return Object.assign({}, state, {
                selectedPortfolio
            });
        }

        case types.USER_LOGGING_IN:
            return Object.assign({}, state, {
                loggingIn: true
            });

        case types.USER_LOGIN_SUCCESS:

            if(sessionStorage){
                sessionStorage.setItem('user', JSON.stringify(action.user));
            }

            return Object.assign({}, state, {
                loggingIn: false,
                user: action.user,
                loginError: false
            });

        case types.USER_LOGIN_FAILED:

            return Object.assign({}, state, {
                loggingIn: false,
                loginError: action.error
            });

        case types.CHECK_USER:{
            if(sessionStorage){
                if(sessionStorage.getItem('user')){
                    return Object.assign({}, state, {
                        loggingIn: false,
                        loginError: false,
                        user: JSON.parse(sessionStorage.getItem('user'))
                    });
                }
                else{
                    return Object.assign({}, state, {
                        loggingIn: false,
                        loginError: false,
                        user: false
                    });
                }
            }else {
                return;
            }
        }



        case types.USER_LOGOUT:

            if(sessionStorage){
                sessionStorage.removeItem('user');
            }

            return Object.assign({}, state, {
                loggingIn: false,
                loginError: false,
                user: false
            });

        default:
            return state;
    }
}



/** WEBPACK FOOTER **
 ** ./src/js/reducers/siteReducer.js
 **/